
class LazyAutocompleteController {
  showResult = false;
  notSelected() {
    return item => {
      return !item.IsSelected;
    };
  }
}

export class LazyAutocomplete implements ng.IComponentOptions {
  static selector = 'lazyAutocomplete';
  static template = require('./lazy-autocomplete.component.html');
  static bindings = {
    items: '='
  };
  static controller = LazyAutocompleteController;
}



// WEBPACK FOOTER //
// ./src/components/lazy-autocomplete/lazy-autocomplete.component.ts